import axios from 'axios'
import history from '../History'
import { ENDPOINT } from '../utils/index'
import store from '../store'

const client = axios.create({
  baseURL: ENDPOINT
})

client.interceptors.request.use(function (config) {
  let token = store.getState().authUser.token
  if (token !== null && token !== '') {
    config.headers.Authorization = `Bearer ${token.accessToken}`
  }
  config.headers['x-bunkey-client'] = store.getState().client.workclient
  return config
}, function (err) {
  return Promise.reject(err)
})

const request = options => {
  const onSuccess = response => {
    return response
  }

  const onError = error => {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }
    if (error.response) {
      // Sólo el 401 es sesión inválida. El 403 es "no tenés permiso para esto":
      // tratarlo como expiración sacaba de la sesión al usuario cada vez que un
      // borrado era denegado. Se propaga al .catch de la acción, que ya muestra
      // la notificación de error.
      if (error.response.status === 401) {
        history.push('/logout')
      }
    } else {
      console.error('Error Message:', error.message)
    }

    return Promise.reject(error.response || error.message)
  }

  return client(options)
    .then(onSuccess)
    .catch(onError)
}

export default request